import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { CustomerLegalDocuments } from "Components/LegalDocuments/CustomerLegalDocuments";
import { HunterLegalDocuments } from "Components/LegalDocuments/HunterLegalDocuments";
import { MerchantLegalDocuments } from "Components/LegalDocuments/MerchantLegalDocuments";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { Resources, useResource } from "Translations/Resources";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import type { ReactNode } from "react";

const USER_TYPE_TO_LEGAL_DOCUMENTS_MAP: Record<AccessRoleCode, ReactNode> = {
  Hunter: <HunterLegalDocuments />,
  HunterPlus: <HunterLegalDocuments />,
  Merchant: <MerchantLegalDocuments />,
  Customer: <CustomerLegalDocuments />,
  Admin: undefined,
  AdminLite: undefined,
  Aml: undefined,
  Employee: undefined,
  CustomerOnboarding: undefined,
  Disponent: undefined,
  Child: undefined,
};

export const LegalDocumentsPage = () => {
  const userType = useCurrentUserRole();
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.LegalDocuments)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content" display="flex" flexDirection="column">
          <PrimaryPaper>
            {userType && USER_TYPE_TO_LEGAL_DOCUMENTS_MAP[userType]}
          </PrimaryPaper>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default LegalDocumentsPage;
